// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__9pPIH","main":"Layout_main__gPKJl"};